import React from 'react';
import { Card } from 'antd';
import { PieChart, Pie, Tooltip, Legend, Cell, ResponsiveContainer } from 'recharts';
import { QnaTicketCountStat } from 'model/response';
import { QA_TICKET_DESCRIPTION, QA_TICKET_STATUS } from 'utils/data';

// Define colors for each segment
const getStatusColor = (status?: string) => {
  switch (status) {
    case QA_TICKET_STATUS.OPEN:
      return 'rgb(230, 126, 34,0.8)';
    case QA_TICKET_STATUS.PROCESS:
      return 'rgb(241, 196, 15,0.8)';
    case QA_TICKET_STATUS.REPORT:
      return 'rgba(239, 68, 68, 0.8)';
    case QA_TICKET_STATUS.CLOSE:
      return 'rgb(52, 152, 219,0.8)';
    default:
      return 'rgba(107, 114, 128, 0.8)'; // Soft Gray for undefined status
  }
};

// Define the component
interface TicketStatusPieChartProps {
  data: QnaTicketCountStat[];
}

const QnaTicketStatusPieChart: React.FC<TicketStatusPieChartProps> = ({ data }) => {
  // Prepare data for Recharts
  const chartData = data?.map((item) => ({
    name: item?.status,
    value: item?.ticketCount,
  }));

  // Custom legend component with circular icons and two-column layout
  const renderCustomLegend = (props: any) => {
    const { payload } = props;
    return (
      <div className="grid grid-cols-2 gap-2 text-left"> 
        {payload.map((entry: any, index: number) => (
          <div key={`item-${index}`} className="flex items-center mb-2 justify-center text-left">
            <span
              className="w-3 h-3 rounded-full mr-2"
              style={{ backgroundColor: entry.color }}
            ></span>
            <span className='!text-[#7f8c8d]'>{QA_TICKET_DESCRIPTION[entry.value as keyof typeof QA_TICKET_DESCRIPTION]}</span>
          </div>
        ))}
      </div>
    );
  };


  return (
    <div style={{ width: '100%' }}>
      <h2 className="text-center text-[16px] font-bold mb-4 text-gray-500">Thống kê phiếu hỏi</h2>
      <ResponsiveContainer width="100%" height={350}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            outerRadius={100}
            fill="#8884d8"
            dataKey="value"
            label={(entry) => `${QA_TICKET_DESCRIPTION[entry.name as keyof typeof QA_TICKET_DESCRIPTION]}: ${entry.value}`}
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={getStatusColor(entry.name)} />
            ))}
          </Pie>
          <Tooltip />
          <Legend
            layout="horizontal"
            align="center"
            verticalAlign="bottom"
            content={renderCustomLegend}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default QnaTicketStatusPieChart;
